<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="0"
      absolute
      auto-height
    >
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>
      {{ message }}
    </v-snackbar>
    <v-row>
      <v-col cols="6" md="6">
        <v-btn v-if="approveOrRejetct" color="#7BC243" to="/farmers/schedule/view" class="white--text cataloguebtn">View All Farmer Schedules</v-btn>
        <v-btn v-else color="#7BC243" to="/farmers/communalRates/view" class="white--text cataloguebtn">View All Farmer Schedules</v-btn>
      </v-col>
    </v-row>
    <v-row>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div :class="paginatedItems.length === 7 ? 'catalogued_box' : 'catalogued_box_empty'">
          <v-card-title>
            <v-row>
            <v-col cols="6" md="6">
              <h3 class="accent--text" style=" font-weight:700"> Farmer Payment Schedule</h3>
            </v-col>
            <v-spacer></v-spacer>

          </v-row>
          </v-card-title>
          <v-card-text>

            <v-row>
              <v-col cols="12" md="6" class="d-flex justify-start">
                <v-col cols="6" md="3" class="d-flex justify-start">
                <v-btn color="blue" @click="showApproveDialog()" rounded  v-if="approveOrRejetct">Approve </v-btn>
                </v-col>
                <v-col cols="6" md="3" class="d-flex justify-start" v-if="approveOrRejetct">
                  <v-btn color="red" @click="showRejectDialog()"  rounded >Reject </v-btn>
                </v-col>
              </v-col>

              <v-col cols="12" md="6" class="d-flex justify-end">
                <v-btn color="primary"   v-if="items.length>0"  @click="exportExcel" rounded >Download </v-btn>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="6" md="3">

                <!--                <h4 class="accent&#45;&#45;text" style="font-size: 12px; font-weight:700"> Current Limit : <span class="amount"> {{-->
                <!--                    currentLimits | formatCurrency-->
                <!--                  }} </span></h4>-->
              </v-col>
            </v-row>
            <table class="table">
              <thead class="thead">
              <tr >
                <th scope="col">Farmer Name</th>
                <th scope="col">National id</th>
                <th scope="col">Member Number</th>
                <th scope="col">Weight</th>

                <th scope="col">Communal Rate</th>
                <th scope="col">Total Amount</th>
                <th v-for="loanType in loanTypes" :key="loanType" >
                  {{ loanType }}
                </th>
                <th scope="col">Net Amount</th>
                <th scope="col">Payment Cycle</th>
                <th scope="col">Pay Channel</th>
                <th scope="col">Account</th>
                <th scope="col">Status</th>

              </tr>
              </thead>
              <tbody>
              <tr v-for="farmerScheduleRecord in paginatedItems" v-bind:key="farmerScheduleRecord.id">
                <td>{{ farmerScheduleRecord.name }}</td>
                <td>{{ farmerScheduleRecord.farmerId }}</td>
                <td>{{ farmerScheduleRecord.memberNumber }}</td>
                <td>{{ farmerScheduleRecord.totalCherryWeight }}</td>

                <td>{{ farmerScheduleRecord.commissionRate }}</td>
                <td>{{ farmerScheduleRecord.initialAmount }}</td>
                <td
                  v-for="loanType in loanTypes"
                  :key="loanType"
                >
                  {{ farmerScheduleRecord[loanType] ?? 0 }}
                </td>
                <td>{{ farmerScheduleRecord.netAmount }}</td>

                <td>{{ farmerScheduleRecord.cycle }}</td>
                <td>{{ farmerScheduleRecord.institutionType }}</td>
                <td>{{ farmerScheduleRecord.accountNumber }}</td>
                <td>{{ farmerScheduleRecord.status }}</td>
              </tr>
              </tbody>
            </table>
          </v-card-text>
          <v-card-actions>
            <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
            <v-spacer></v-spacer>
            <v-pagination
              v-model="page"
              :length="numberOfLinks"
              :total-visible="7"
              color="secondary"
                class="accent--text logoutbtn"
            ></v-pagination>
          </v-card-actions>
        </div>
      </v-col>
    </v-row>

    <v-dialog v-model="approveDialog" persistent width="500">
      <v-card>
        <v-card-title class="headline primary--text">Approve Payment Schedule</v-card-title>
        <v-card-text>
          <v-flex xs8>
            <h5> Are you sure you want to approve the payment Schedule? </h5>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="cancelDialog">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="approveRecord">Approve</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="rejectDialog" persistent width="500">
      <v-card>
        <v-card-title class="headline primary--text">Reject Payment Schedule</v-card-title>
        <v-card-text>
          <v-flex xs8>
            <h5> Are you sure you want to reject the payment Schedule? </h5>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="cancelRejectDialog">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="rejectRecord">Reject</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import { mapState } from 'vuex'
import { previousRoute } from '@/router';
import * as XLSX from "xlsx";

export default {
	name: 'ViewFarmerSchedule',
	data: function () {
		return {
			items: [],
      loanTypes:[],
      pivotedData: [],
			message: '',
			loading: false,
			snackbar: false,
			snackbarColor: '',
			messsage: '',
			paginatedItems: [],
			permissions: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			documentId: 0,
			approveDialog: false,
			rejectDialog: false,
			approverComments: '',
      approveOrRejetct: false,
      organisationId: ''
		}
	},
	computed: {
		...mapState({
			limit: state => state.farmer.limit

		}),
		currentLimits () {
			return this.items?.borrowerLimit?.availableBalance
		},
		// title () {
		// 	return 'Payment Schedule for ' + ' ' + this.items?.borrowerLimit?.name + ' Mobile ' + this.items?.borrowerLimit?.mobileNumber
		// }
    filteredList: function () {
      if (this.search === '') {
        return this.paginatedItems
      } else {
        return this.communalPayments.filter(communalPayment => { return (communalPayment.season !== null ? communalPayment.season.toLowerCase().includes(this.search.toLowerCase()) : ''.toLowerCase().includes(this.search.toLowerCase())) || (communalPayment.organisation?.organisationName === null ? ''.toLowerCase().includes(this.search.toLowerCase()) : communalPayment.organisation?.organisationName.toLowerCase().includes(this.search.toLowerCase())) })
      }
    }
  },
	watch: {
		pivotedData() {
			this.numberOfLinks = Math.ceil(this.pivotedData?.length / this.numberOfItemsPerPage)
			this.paginatedItems = this.paginationMethod(this.pivotedData, 1, this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedItems = this.paginationMethod(this.pivotedData, val, this.numberOfItemsPerPage)
		}
	},
	mounted () {
    this.theUser = JSON.parse(localStorage.getItem('user'))
    console.log('user ===>> ', this.theUser)
    this.organisationType = this.theUser.organisation.organisationType.name
    this.organisationId = this.theUser.organisation.id
    if(this.$route.params.action === 'approve'){
      this.approveOrRejetct = true;
    }
    console.log('Previous page:', previousRoute?.path)
		this.getFarmerPaymentScheduleDetails()
	},
	methods: {
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		getFarmerLoanDetails () {
			const url = config.serverURI + '/disbursement/farmer/history/' + this.$route.params.organizationId + '/' + this.$route.params.farmerId
			axios.get(url)
				.then(response => {
					this.items = response.data
				})
				.catch(error => {
					console.log('error', error.response)
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},

		getFarmerPaymentScheduleDetails () {
			var url = config.serverURI;
      if(this.approveOrRejetct){
        url = url + '/payment/getPendingPaymentSchedule/' +  this.organisationId + '/'+this.$route.params.commId
      }
      else{
        url = url + '/payment/getScheduleByCommId/' +  this.organisationId  + '/'+ this.$route.params.commId
      }
      console.log("url",url)
			axios.get(url)
				.then(response => {
					this.items = response.data.data

          console.log("farmer schedule",this.items)

          const loanTypeSet = new Set(this.items
            .filter(item => item && item.loanType != null)
            .map(item => item.loanType))
          this.loanTypes = Array.from(loanTypeSet)

          const grouped = {}

          this.items.forEach(item => {
            const key = item.farmerId
            if (!grouped[key]) {
              grouped[key] = {
                farmerId: item.farmerId,
                name: item.name,
                memberNumber: item.memberNumber,
                totalCherryWeight: item.totalCherryWeight,
                commissionRate: item.commissionRate,
                initialAmount : item.initialAmount,
                netAmount: item.netAmount,
                cycle: item.cycle,
                institutionType: item.institutionType,
                accountNumber: item.accountNumber,
                status: item.status,
                season: item.season,
                orgName: item.orgName,
                accountName: item.accountName
              }
            }
            // Assign loan amount to loan type column
            console.log("before",item.loanType)
            if(item.loanType) {
              console.log("test null",item.loanType)
              grouped[key][item.loanType] = item.loanAmount
            }
          })

          this.pivotedData = Object.values(grouped)
				})
				.catch(error => {
					console.log('error', error.response)
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
    exportExcel () {
      // Define worksheet and workbook
      const ws = XLSX.utils.json_to_sheet(this.pivotedData
        //   {
        //     header: Object.keys(this.headers)
        //   }
      )
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

      // Export workbook to file
      XLSX.writeFile(wb,  'Farmer_PaymentSchedule_' + Date.now() + '.xlsx')
    },
		showApproveDialog () {
			this.approveDialog = true
		},
		cancelDialog () {
			this.approveDialog = false
		},
		cancelRejectDialog () {
			this.rejectDialog = false
		},
		showRejectDialog () {
			this.rejectDialog = true
		},
		approveRecord () {
			const url = config.serverURI + '/payment/approveFarmerSchedule/'+this.organisationId
			axios.post(url, {
				commId: this.$route.params.commId,
				action: 'APPROVE'

			})
				.then(response => {
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						console.log('Error is ' + this.message)
						this.approveDialog = false
						return
					}
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.approveDialog = false
					this.$router.push('/farmers/schedule/view')
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred while processing your request'
					this.snackbar = true
					this.snackbarColor = 'error'
					this.approveDialog = false
				})
		},
		rejectRecord () {
			const url = config.serverURI + '/payment/approveFarmerSchedule/'+this.organisationId
			axios.post(url, {
				commId: this.$route.params.commId,
				action: 'REJECT'

			})
				.then(response => {
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						console.log('Error is ' + this.message)
						this.rejectDialog = false
						return
					}
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.rejectDialog = false
					this.$router.push('/farmers/schedule/view')
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred while processing your request'
					this.snackbar = true
					this.snackbarColor = 'error'
					this.rejectDialog = false
				})
		}
	}
	// ,
	// created () {
	// 	this.$store.dispatch('farmer/getFarmerLimit', this.$route.params.farmerId)
	// }
}

</script>
<style scoped >
.catalogued_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogued_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogued_box:after, .catalogued_box:before {
  right: 100%;
  top: 23%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogued_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}

.catalogued_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.amount {
  color: black;
  font-weight: 700;
  font-size: 14px;
}
</style>
